import axiosInstance from 'config/axios';

const getTwilioToken = data => {
  return axiosInstance.post(`v1/video-chat/token`, data);
};
export default {
  getTwilioToken,
};
